import {ChangeDetectorRef, Component, ElementRef, OnDestroy, ViewChild} from "@angular/core";
import {Page} from "../../orchestration/page";
import {MenuModel, MenuItemInCategory} from "../menu.model";
import {Observable, Subject, Subscription} from "rxjs";
import {MessageLevel} from "../../notification/message/message";
import {MenuEvents} from "../menu-events";
import {NavigationService} from "../../orchestration/navigation.service";
import {AnalyticsService} from "../../orchestration/analytics.service";

@Component({
    selector: "woa-menu-search-page",
    templateUrl: "./menu-search-page.component.html",
    providers: [{provide: Page, useExisting: MenuSearchPageComponent}]
})
export class MenuSearchPageComponent extends Page implements OnDestroy {
    MessageLevel = MessageLevel;

    @ViewChild("input", {read: ElementRef}) protected inputER: ElementRef;

    itemsInCategories: MenuItemInCategory[] = [];

    private subscriptions: Subscription = new Subscription();
    private _searchText: string = "";
    private searchText$: Subject<string> = new Subject<string>();
    private searchTextDebouncer: Observable<string> = this.searchText$.debounceTime(1000);

    constructor(public menuModel: MenuModel,
                private navigationService: NavigationService,
                private changeDetectorRef: ChangeDetectorRef,
                private analyticsService: AnalyticsService) {
        super();
        this.subscriptions.add(this.searchTextDebouncer.subscribe((searchText: string) => this.search(searchText)));
        this.subscriptions.add(MenuEvents.categorySelected$.subscribe(() => this.navigationService.dismissPage(this)));
    }

    onActive(): void {
        setTimeout(() => this.inputER.nativeElement.focus(), 500);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get searchText(): string {
        return this._searchText;
    }

    set searchText(searchText: string) {
        this._searchText = searchText;
        this.searchText$.next(searchText);
    }

    private search(searchText): void {
        // noinspection JSIgnoredPromiseFromCall
        this.analyticsService.trackSearchInitiated();
        this.itemsInCategories = this.menuModel.searchItems(searchText);
        this.changeDetectorRef.detectChanges();
    }
}



// WEBPACK FOOTER //
// ./src/app/menu/menu-search-page/menu-search-page.component.ts